export const GET_COMPANIES_LIST = "GET_COMPANIES_LIST";

export const UPDATE_MY_CUSTOMER_COMPANY = "UPDATE_MY_CUSTOMER_COMPANY";
